export const quizPercentage = (totalRight, totalQuestions) => {
  //Total right: amount of questions that user got right
  //Total Questions: length of the questions in the quiz
  const total = Math.floor((totalRight / totalQuestions) * 100);
  return total > 100 ? 100 : total;
};
